import { mostRead } from "../../data/resourcesData";
import ResourceHero from "./ResourceHero";
import "../../css/MostRead.css";

export default function MostRead() {
  return (
    <>
      <ResourceHero
        title="Most Read"
        subtitle="Stay updated with the latest educational insights, school news, learning tips, and inspiring stories from our community."
        image="/images/Education_Funds4.png"
      />


      <section className="resources-section" id="most-read">

        <div className="resources-heading-row">

          <h2 className="resources-heading">
            Most Read
          </h2>

        </div>


        <div className="most-read-wrapper">

          {mostRead.map((item, index) => (

            <a
              href={item.href}
              key={index}
              className="most-read-item"
            >

              <span className="most-read-number">
                {index + 1}
              </span>


              <h3>
                {item.title}
              </h3>

            </a>

          ))}

        </div>

      </section>



      <section className="why-read-section">

        <div className="container why-read-wrapper">


          <div className="why-read-content">

            <span>
              Knowledge Hub
            </span>


            <h2>
              Learn, Explore & Stay Inspired
            </h2>


            <p>
              Our articles are carefully written to support students,
              parents and educators with practical knowledge,
              educational trends and valuable school updates.
            </p>


            <ul>

              <li>
                Latest Education News & Updates
              </li>

              <li>
                Student Success Stories
              </li>

              <li>
                Parenting & Learning Tips
              </li>

              <li>
                Exam Preparation Guidance
              </li>

              <li>
                School Events & Activities
              </li>

            </ul>

          </div>



          <div className="why-read-image">

            <img
              src="/images/mr.jpeg"
              alt="Students"
            />

          </div>


        </div>

      </section>



      <section className="featured-topics">


        <div className="container">


          <div className="section-heading">


            <span>
              Explore More
            </span>


            <h2>
              Featured Reading Topics
            </h2>


            <p>
              Discover articles covering academics, innovation,
              student life and holistic development.
            </p>


          </div>



          <div className="topics-grid">


            <div className="topic-card">

              <h3>
                Academic Excellence
              </h3>

              <p>
                Learning strategies and classroom success stories.
              </p>

            </div>



            <div className="topic-card">

              <h3>
                Student Development
              </h3>

              <p>
                Personality growth, leadership and communication skills.
              </p>

            </div>



            <div className="topic-card">

              <h3>
                Parent Resources
              </h3>

              <p>
                Helpful guides to support children's learning journey.
              </p>

            </div>



            <div className="topic-card">

              <h3>
                School Updates
              </h3>

              <p>
                Events, achievements and important announcements.
              </p>

            </div>


          </div>


        </div>


      </section>

    </>
  );
}